import React from 'react';
import { Box, TextField as MuiTextField } from '@mui/material';
import type { BaseTextFieldProps } from '@mui/material/TextField';

import { IconName } from './IconButton';

type TextFieldRef = Record<string, unknown>;

const TextField = React.forwardRef<
	TextFieldRef,
	{
		m?: string;
		p?: string;
		width?: string;
		startLabel?: string;
		startIconName?: IconName;
		startIconNameColor?: string;
		onClickStartIcon?: () => void;
		endLabel?: string;
		endIconName?: IconName;
		onChange?: (value: string) => void;
		flex?: boolean;
		toolTip?: string;
		isLoading?: boolean;
		maxLength?: number;
	} & BaseTextFieldProps
>(
	(
		{
			m,
			p,
			flex,
			width,
			startLabel,
			startIconName,
			startIconNameColor,
			onClickStartIcon,
			endLabel,
			endIconName,
			onChange,
			toolTip,
			isLoading,
			maxLength,
			...rest
		},
		ref
	) => {
		const handleChange = React.useCallback(
			(event) => {
				const newValue = event?.target?.value;
				onChange?.(newValue);
			},
			[onChange]
		);

		return (
			<Box m={m} p={p} flex={flex ? '1' : undefined} width={width} ref={ref}>
				<MuiTextField
					fullWidth
					onChange={handleChange}
					value={isLoading ? '...lade' : undefined}
					disabled={isLoading}
					type="text"
					{...rest}
				/>
			</Box>
		);
	}
);

export default React.memo(TextField);
